"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChimeRemoteDataTrack = exports.ChimeLocalDataTrack = void 0;
const rxjs_1 = require("rxjs");
const streem_sdk_protobuf_1 = require("streem-sdk-protobuf");
const streem_logger_1 = require("../util/streem_logger");
const DATA_MESSAGE_TOPIC = 'tool-engine-data-track';
class ChimeLocalDataTrack {
    constructor(audioVideoFacade) {
        this.audioVideoFacade = audioVideoFacade;
        this.logger = streem_logger_1.streemLogger.extend('sdk-chime-video:ChimeLocalDataTrack');
    }
    send(message) {
        // data is a Uint8Array, which is sent by chime without extra encoding:
        // https://github.com/aws/amazon-chime-sdk-js/blob/main/src/task/SendAndReceiveDataMessagesTask.ts#L68
        const data = streem_sdk_protobuf_1.streem.room.DataTrackMessage.encode(message).finish();
        this.audioVideoFacade.realtimeSendDataMessage(DATA_MESSAGE_TOPIC, data);
    }
    disconnect() {
        this.logger.info('ChimeLocalDataTrack disconnecting from data messages.');
        // nothing to do
    }
}
exports.ChimeLocalDataTrack = ChimeLocalDataTrack;
class ChimeRemoteDataTrack {
    constructor(audioVideoFacade) {
        this.audioVideoFacade = audioVideoFacade;
        this.logger = streem_logger_1.streemLogger.extend('sdk-chime-video:ChimeRemoteDataTrack');
        this.messages = new rxjs_1.Observable(subscriber => {
            this.audioVideoFacade.realtimeSubscribeToReceiveDataMessage(DATA_MESSAGE_TOPIC, (dataMessage) => {
                const msg = streem_sdk_protobuf_1.streem.room.DataTrackMessage.decode(new Uint8Array(dataMessage.data));
                subscriber.next(msg);
            });
        });
    }
    disconnect() {
        this.logger.info('ChimeRemoteDataTrack disconnecting from data messages.');
        this.audioVideoFacade.realtimeUnsubscribeFromReceiveDataMessage(DATA_MESSAGE_TOPIC);
    }
}
exports.ChimeRemoteDataTrack = ChimeRemoteDataTrack;
//# sourceMappingURL=data_tracks.js.map